<script>
import CustomTransition from 'linna/components/CustomTransition'

export default {
  name: 'SlowFade',

  components: {
    CustomTransition
  },

  props: [
    'mode',
    'appear'
  ]

}
</script>

<template>
  <custom-transition
    :mode="mode"
    :appear="appear"
    name="slow-fade"
  ><slot /></custom-transition>
</template>

<style lang="scss">

.transition-slow-fade-enter-active,
.transition-slow-fade-leave-active {
  // opacity: 1;
  @include transition-properties-common;

  transition-duration: 5s;
}

// Start state for enter
.transition-slow-fade-enter,

// End state for exit
.transition-slow-fade-leave-to {
  opacity: 0;
}

</style>
